import React from 'react';
import {
  SectionWixFooter,
  ISectionProps,
  ITextSection,
} from '@wix/shoutout-email-react';
import { useWixFooterContent, WixFooterType } from '@wix/wix-emails-senders';

interface PropTypes extends ISectionProps {
  isRtl: boolean;
  section: ITextSection & { footerType: WixFooterType };
  backgroundColor: string;
  columnCssClass: string;
  cssClass: string;
  experiments: Record<string, string>;
}

export const SectionWixFooterWithContent = (props: PropTypes) => {
  const { getWixFooterContent } = useWixFooterContent();
  const content = getWixFooterContent(props.section.footerType);

  return <SectionWixFooter {...props} content={content} />;
};
